import styled from 'styled-components';

import { media } from '../../utils/mediaQueries';

export const Container = styled.div`
  max-width: 350px;
  width: 100%;
  background: transparent;
  border-radius: 6px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${media.mobile} {
    padding: 16px;
    gap: 16px;
    max-width: 100%;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;

  ${media.mobile} {
    gap: 10px;
  }
`;

export const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 6px;
  background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(224, 123, 45, 0.15)' : '#e6f2f2')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  ${media.mobile} {
    width: 40px;
    height: 40px;
    border-radius: 6px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const Title = styled.h3`
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f8fafc' : '#0f172a')};

  ${media.mobile} {
    font-size: 16px;
    margin: 0 0 2px 0;
  }
`;

export const Description = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#64748b')};
  line-height: 1.5;

  ${media.mobile} {
    font-size: 12px;
    line-height: 1.4;
  }
`;

export const QrWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const QrContainer = styled.div`
  padding: 24px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f8fafc')};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
`;

export const QrLabel = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 300;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#64748b')};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PrimaryButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  background: linear-gradient(135deg, #1a4d4d, #0f3333);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 300;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: opacity 0.2s;

  ${media.mobile} {
    padding: 10px 14px;
    font-size: 14px;
    border-radius: 6px;
    gap: 6px;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  &:hover {
    opacity: 0.9;
  }
`;

export const SecondaryButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : 'white')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#475569')};
  border: 2px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
  border-radius: 6px;
  font-size: 15px;
  font-weight: 300;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;

  ${media.mobile} {
    padding: 10px 14px;
    font-size: 14px;
    border-radius: 6px;
    gap: 6px;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  &:hover {
    border-color: #1a4d4d;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e6f2f2')};
  }
`;

export const UrlContainer = styled.div`
  padding: 12px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f8fafc')};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${media.mobile} {
    padding: 10px;
    border-radius: 6px;
  }
`;

export const UrlLabel = styled.span`
  font-size: 12px;
  font-weight: 300;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#64748b')};
  text-transform: uppercase;
  letter-spacing: 0.5px;

  ${media.mobile} {
    font-size: 10px;
  }
`;

export const UrlText = styled.span`
  font-size: 13px;
  color: #1a4d4d;
  font-weight: 500;
  word-break: break-all;

  ${media.mobile} {
    font-size: 12px;
  }
`;

export const MobileCtaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px 0;
`;
